import React, { FC } from "react";
import { Badge, Card, Col, Row, Spinner } from "react-bootstrap";

import { AppUserType } from "../../../../DTO";
import { formatUserId } from "../../../../utils";

type HeaderCardProps = {
    userId: number;
    userContext?: AppUserType;
    loadingUserContext: boolean;
    selectedWeekIndex?: number | null;
};

export const HeaderCard: FC<HeaderCardProps> = ({
    userId,
    userContext,
    loadingUserContext,
    selectedWeekIndex,
}) => {
    const fullName =
        userContext?.firstName || userContext?.lastName
            ? `${userContext?.firstName || ""} ${userContext?.lastName || ""}`.trim()
            : "-";
    const displayUserId =
        userContext?.displayUserId ||
        formatUserId(userId, userContext?.createdAt);

    return (
        <Card className="summary-hero shadow-sm border-0">
            <Card.Body className="p-3 p-md-4">
                <div className="summary-hero-top">
                    <div>
                        <div className="summary-caption">Nutrition Insights</div>
                        <h1 className="h4 mb-1">User Summary</h1>
                        <div className="text-muted small">
                            Daily and weekly nutrition performance overview
                        </div>
                    </div>

                    <div className="d-flex flex-wrap gap-2 align-items-center">
                        {(selectedWeekIndex ?? 0) > 0 && (
                            <Badge bg="light" text="dark" className="summary-week-chip">
                                Week #{selectedWeekIndex}
                            </Badge>
                        )}
                        <Badge bg="secondary" className="summary-user-chip">
                            User {displayUserId}
                        </Badge>
                    </div>
                </div>

                <div className="summary-divider" />

                {loadingUserContext ? (
                    <div className="d-flex align-items-center gap-2">
                        <Spinner size="sm" animation="border" />
                        <span className="text-muted small">Loading user context...</span>
                    </div>
                ) : (
                    <Row className="g-2">
                        <Col md={4}>
                            <div className="summary-meta-card">
                                <div className="summary-meta-label">User ID</div>
                                <div className="summary-meta-value">{displayUserId}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="summary-meta-card">
                                <div className="summary-meta-label">Full Name</div>
                                <div className="summary-meta-value">{fullName}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="summary-meta-card">
                                <div className="summary-meta-label">Email</div>
                                <div className="summary-meta-value">{userContext?.email || "-"}</div>
                            </div>
                        </Col>
                    </Row>
                )}
            </Card.Body>
        </Card>
    );
};
